module.exports = __webpack_public_path__ + "media/images/tmp/mag2-d2fcc53f318d4be537fa09ef303653de.png";